import {Card} from '@vector';
import clsx from 'clsx';
import styles from './FeatureTile.module.css';

export default function FeatureTile({label, icon: Icon, tone = 'raised', hero = false}) {
    const dark = tone === 'inverse';
    const iconColor = tone === 'accent' ? 'currentColor'
        : tone === 'inverse' ? 'var(--home-color-orange)'
        : tone === 'secondary' ? 'var(--home-color-secondary-text)'
        : 'var(--color-text-secondary)';

    return (
        <Card
            as="li"
            surface={tone}
            className={clsx(styles.tile, hero && styles.tileHero)}
            style={dark ? {color: 'var(--color-text-on-brand)'} : undefined}>
            <Icon size={hero ? 96 : 48} color={iconColor}/>
            <span className={clsx(styles.label, hero && styles.labelHero)}>{label}</span>
        </Card>
    );
}
